import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withApollo } from "react-apollo";
import StudentAttendanceHome from "./StudentAttendanceHome";

const FETCH_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                stream_id
                section_name
            }
        }
    }
`;

const GET_STREAMS = gql`
    query {
        getStreams {
            id
            stream
        }
    }
`;

const GET_ACADEMIC_YEARS = gql`
    query getAcademicYears($id: Int) {
        getAcademicYears(id: $id) {
            id
            academic_year
        }
    }
`;

const GET_CLASSES = gql`
    query($id: Int) {
        getExamClasses(id: $id) {
            id
            class
        }
    }
`;

// Renders the full Student Attendance marking flow inside a popup, fetching the
// same data the standalone /student/attendance page uses.
class StudentAttendanceModal extends Component {
    render() {
        const { getBranches, getAcademicYearsQuery, getExamClasses, getStreamsQuery } = this.props;
        const loading =
            getBranches.loading ||
            getAcademicYearsQuery.loading ||
            getExamClasses.loading ||
            (getStreamsQuery && getStreamsQuery.loading);

        return (
            <Modal show={this.props.show} onHide={this.props.onHide} size="xl" aria-labelledby="student-attendance-modal">
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontSize: 17, fontWeight: 700, color: "#0f172a", display: "flex", alignItems: "center", gap: 9 }}>
                        <i className="fal fa-user-check" style={{ color: "#7c3aed" }} />Mark Student Attendance
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: "#fff", padding: "0 8px 8px", height: "calc(100vh - 130px)", overflowY: "auto" }}>
                    {loading ? (
                        <div style={{ padding: 40, textAlign: "center" }}>
                            <div className="spinner-border text-primary" />
                        </div>
                    ) : (
                        <StudentAttendanceHome
                            embedded
                            branches={getBranches.getBranches || []}
                            academicYears={getAcademicYearsQuery.getAcademicYears || []}
                            classes={getExamClasses.getExamClasses || []}
                            streams={(getStreamsQuery && getStreamsQuery.getStreams) || []}
                        />
                    )}
                </Modal.Body>
            </Modal>
        );
    }
}

export default withApollo(
    compose(
        graphql(FETCH_BRANCHES, {
            options: () => ({
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            }),
            name: "getBranches",
        }),
        graphql(GET_ACADEMIC_YEARS, {
            name: "getAcademicYearsQuery",
            options: { variables: { id: 1 } },
        }),
        graphql(GET_CLASSES, {
            name: "getExamClasses",
            options: { variables: { id: 1 } },
        }),
        graphql(GET_STREAMS, {
            name: "getStreamsQuery",
            options: { fetchPolicy: "network-only" },
        }),
    )(StudentAttendanceModal)
);
